import { render, staticRenderFns } from "./PendingPay.vue?vue&type=template&id=2f5975d9&scoped=true"
import script from "./PendingPay.vue?vue&type=script&lang=js"
export * from "./PendingPay.vue?vue&type=script&lang=js"
import style0 from "./PendingPay.vue?vue&type=style&index=0&id=2f5975d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5975d9",
  null
  
)

export default component.exports